import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { succsesDataChangeAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CurrentShipper = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const { id } = useParams();

    const [active, setActive] = useState(0);
    const [title, setTitle] = useState("");
    const [shortTitle, setShortTitle] = useState("");
    const [stickerTitle, setStickerTitle] = useState("");

    const { data: shipper, refetch: refetchShipper } = useGetPageQuery("shippers/" + id);
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    const sendFormHandler = async () => {
        const formData = {
            title: title,
            title_short: shortTitle,
            title_sticker: stickerTitle,
            active: active,
        };

        await sendForm({ body: formData, url: "shippers/" + id, method: "PUT" }).unwrap();
        await refetchShipper();

        if (!isError) {
            succsesDataChangeAlert();
            navigate("/shippers/1");
        }
    };

    useEffect(() => {
        if (shipper) {
            setActive(shipper.active);
            setTitle(shipper.title);
            setShortTitle(shipper.title_short);
            setStickerTitle(shipper.title_sticker);
        }
    }, [shipper]);

    return (
        <div className="content">
            <div className="col-12">
                <div id="page-header">
                    <h1>Новий постачальник</h1>
                </div>
                <div className="form user_form">
                    <input type="hidden" name="id" value="" />
                    <div className="row">
                        <div className="col-12 col-sm-6 col-lg-6">
                            <div className="card card-default">
                                <div className="card-header">
                                    Інформація про постачальника
                                    <div className="form-check float-end">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            defaultChecked={active}
                                            onChange={(e) => setActive(e.target.checked)}
                                        />
                                        <label className="form-check-label" for="check_enabled">
                                            Активний
                                        </label>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="mb-2">
                                        <label className="form-label">Назва</label>
                                        <input
                                            className="form-control"
                                            maxLength="255"
                                            type="text"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Коротка назва</label>
                                        <input
                                            className="form-control"
                                            maxLength="255"
                                            type="text"
                                            value={shortTitle}
                                            onChange={(e) => setShortTitle(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Назва на наклейці</label>
                                        <input
                                            className="form-control"
                                            maxLength="255"
                                            type="text"
                                            value={stickerTitle}
                                            onChange={(e) => setStickerTitle(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            {permissions.includes("shipper_edit") || permissions.includes("all") ? (
                                <div className="saves_block">
                                    <button className="btn btn-labeled btn-primary" onClick={sendFormHandler}>
                                        {isLoading ? "Завантаження" : "Зберегти"}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                        <div className="col-12 col-sm-6 col-lg-6"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CurrentShipper;
